import { ColumnDef } from "@tanstack/react-table";
import { TaxComponentAccountResponse } from "@/app/types";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Edit, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DataTableColumnHeader } from "./columnsAccountType";

// Define columns for the TaxComponentAccount data table
export const columns: ColumnDef<TaxComponentAccountResponse>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => <DataTableColumnHeader column={column} title="ID" />,
    cell: ({ row }) => <div className="w-12">{row.getValue("id")}</div>,
  },
  {
    accessorKey: "tax_component_name",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Tax Component" />,
    cell: ({ row }) => <div className="font-medium">{row.getValue("tax_component_name") || "-"}</div>,
  },
  {
    accessorKey: "account_name",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Account" />,
    cell: ({ row }) => <div>{row.getValue("account_name") || "-"}</div>,
  },
  {
    accessorKey: "account_code",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Account Code" />,
    cell: ({ row }) => <div className="font-mono">{row.getValue("account_code") || "-"}</div>,
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const taxComponentAccount = row.original;
      
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem 
              className="cursor-pointer"
              onClick={() => document.dispatchEvent(
                new CustomEvent("edit-tax-component-account", { detail: taxComponentAccount })
              )}
            >
              <Edit className="mr-2 h-4 w-4" />
              <span>Edit</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer text-destructive"
              onClick={() => document.dispatchEvent(
                new CustomEvent("delete-tax-component-account", { detail: taxComponentAccount })
              )}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              <span>Delete</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];

// Define which columns can be searched by text
export const searchableColumns = [
  {
    id: "tax_component_name",
    title: "Tax Component",
  },
  {
    id: "account_name",
    title: "Account",
  },
  {
    id: "account_code",
    title: "Account Code",
  },
]; 